import { render } from "./OrderManageView.vue?vue&type=template&id=1a3dcd39&scoped=true"
import script from "./OrderManageView.vue?vue&type=script&lang=js"
export * from "./OrderManageView.vue?vue&type=script&lang=js"

import "./OrderManageView.vue?vue&type=style&index=0&id=1a3dcd39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3dcd39"]])

export default __exports__